module.exports = __webpack_public_path__ + "img/LEND.d5d3adc2.svg";